import { Paper, Stack, Skeleton, Box } from '@mui/material'

export const ResultCardSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      display: 'flex',
      alignItems: 'stretch',
      gap: 2,
      p: 1.4,
      width: '100%',
      borderRadius: '6px',
      backgroundColor: 'secondary.main',
    }}
  >
    <Stack
      spacing={1}
      sx={{
        flex: 1,
        minWidth: 0,
        justifyContent: 'space-evenly',
      }}
    >
      <Skeleton variant='text' width='60%' height={32} />

      <Skeleton variant='text' width='20%' height={24} />

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Skeleton variant='text' width='150px' height={24} />
        <Skeleton variant='text' width='250px' height={24} />
        <Skeleton variant='text' width='120px' height={24} />
      </Box>
    </Stack>

    <Stack
      spacing={1}
      justifyContent='space-evenly'
      alignItems='flex-end'
      sx={{ minWidth: 140 }}
    >
      <Skeleton variant='rounded' width={120} height={36} />
      <Skeleton variant='rounded' width={120} height={36} />
    </Stack>
  </Paper>
)
